<template>

<ion-card
 :style="{ '--i': i }"
  v-if="item.idBlockType === 5"
  class="signature-card"
>
  <ion-card-header>
    <div class="header-content">
      <ion-card-title class="classtitle text-20">{{ item.nome }} </ion-card-title>
      
    </div>
  </ion-card-header>
  <ion-card-content>
    <p class="description">{{ item.signatureDocument.description }} </p>
      <div class="iframe-container"
                    >
      <iframe
                        :src="item.signatureDocument.fileUrl"
                        frameBorder="0"
                        scrolling="auto"
                        width="100%"
                        height="100%"
                      ></iframe>
                      </div>
        <ion-button expand="block" style="margin-left: 22%; margin-top: 1rem;" @click="openChapter(item.learningChapter)">
          FIRMA ORA
        </ion-button>
  </ion-card-content>
</ion-card>
</template>
<script>
import { defineComponent } from "vue";
import quizStore from "@/stores/useQuizStore";
export default defineComponent({
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  methods: {
    openChapter: function (learningChapter) {
      if (learningChapter.id_survey) {
        quizStore.setParentId(this.$route.params.id);
        quizStore.setParent(learningChapter.id_categoria);
        quizStore.setParentTitle(learningChapter.title['it-IT']);

        this.$router.push({
          name: "campaign_quiz",
          params: {
            chapter: learningChapter.id,
            id: learningChapter.id_survey,
            title: learningChapter.title,
            parentId: this.$route.params.id,
            parent: learningChapter.id_categoria,
            parentTitle: learningChapter.title['it-IT'],
          },
        });
        return;
      }
    },
  },
});
</script>
<style scoped>

.text-20 {
  font-family: 'Poppins', sans-serif;
  font-size: 16px;
  font-weight: bold;
  text-transform: capitalize;
  color: white;
}

ion-card-header {
  opacity: 0;
  transform: translateY(20px);
  animation: fadeInUp 0.4s ease forwards;
}
.signature-card {
  //background: var(--folder-bg-color) !important;
  background: black !important;
  color: #fff;
  border-radius: 16px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
  overflow: hidden;
  position: relative;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}
.signature-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.3);
}
.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.classtitle {
  font-family: 'Poppins', sans-serif;
  font-size: 20px;
  font-weight: bold;
  margin: 8px 0;
}
.description {
  margin: 16px 0;
  line-height: 1.6;
}


</style>

